<template>

         <v-card>
         <v-card-title>
            <span class="headline">Add Student</span>
         </v-card-title>
         <v-card-text>
            <v-container>
               <v-row>
               <v-col
                  cols="12"
                  sm="6"
                  md="6"
               >
                  <v-text-field
                     v-model="student.firstname"
                     label="First name*"
                     required
                  ></v-text-field>
               </v-col>
               <v-col
                  cols="12"
                  sm="6"
                  md="6"
               >
                  <v-text-field
                     v-model="student.lastname"
                     label="Last name"
                     required
                  ></v-text-field>
               </v-col>

                  <v-col 
                 cols="12"
                  sm="6"
                  md="6"
               >
                    <v-text-field
                     v-model="student.email"
                     label="Email*"
                     required
                  ></v-text-field>
               </v-col>


               <v-col 
                 cols="12"
                  sm="6"
                  md="6"
               >
                <v-radio-group
                     v-model="student.gender"
                     row
                  >
                     <v-radio
                     label="Male"
                     value="male"
                     ></v-radio>
                     <v-radio
                     label="Female"
                     value="female"
                     ></v-radio>
                  </v-radio-group>
               </v-col>
                    <v-col 
                 cols="12"
                  sm="6"
                  md="6">

                   <v-select
                     v-model="student.grade"
                     :items="gradeItems"
                     label="Current Grade"
                  ></v-select>
               </v-col>

                  <v-col 
                 cols="12"
                  sm="6"
                  md="6"
               >
                  <v-menu
                     ref="menu"
                     v-model="menu"
                     :close-on-content-click="false"
                     transition="scale-transition"
                     offset-y
                     min-width="290px"
                  >
                     <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                        v-model="student.dob"
                        label="Birthday date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        ></v-text-field>
                     </template>
                     <v-date-picker
                        ref="picker"
                        v-model="date"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="save"
                     ></v-date-picker>
                  </v-menu>
               </v-col>
                    <v-col 
                 cols="12"
                  sm="6"
                  md="6"
               >
                <v-select
                     v-model="student.school"
                     :items="schoolItems"
                     label="School"
                  ></v-select>
               </v-col>

               
               <v-col
                  cols="12"
               >
               <v-textarea
                  v-model="student.about"
                  outlined
                  label="About"
                  ></v-textarea>
               
               </v-col>
               </v-row>
            </v-container>
         </v-card-text>
         <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
               color="darken-1"
               text
               @click="closeDialog"
            >
               Close
            </v-btn>
            <v-btn
               color="blue darken-1"
               text
               @click="closeDialog"
            >
               Save
            </v-btn>
         </v-card-actions>
         </v-card>


</template>


<script>
    export default {
       data: () => ({
         // direction: 'left',
         fab: false,
      
         student: {
            firstname: "John",
            lastname: "Doe",
            email: "testmail@email.com",
            dob: "01/01/2000",
            gender: "male",
            grade: "1",
            school: "School 1",
            about:"This is a test description about the student"
         },
         gradeItems: ['Nursery', 'Pre-K', 'K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'College', 'Adult'],
         schoolItems: ['School 1', 'School 2', 'School 3'],
     
         date: null,
         menu: false

       }),
      methods: {
         closeDialog () {
            this.$emit('mclosedialog')
         },
         save (date) {
            this.$refs.menu.save(date)
         },
      },
      watch: {
         menu (val) {
         val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
         },
      },
     }
</script>
<style></style>
